



















import Component from "vue-class-component";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import CAddressEditor from "@/components/CAddressEditor.vue";
import Validation from "@/chipply/Validation";
import CheckoutReviewViewModel from "@/chipply/view-model/CheckoutReviewViewModel";
import { mask } from "vue-the-mask";
import FieldValueCollectionEditor from "../common-vue/FieldValueCollectionEditor.vue";

@Component({
    components: {
        CAddressEditor,
        FieldValueCollectionEditor,
    },
    directives: {
        mask,
    },
})
export default class CheckoutAdditionalInfoForm extends Vue {
    public name = "CheckoutAdditionalInfoForm";
    public Validation = Validation;

    @Prop({ type: Object })
    public stepStatus!: { advancing: false; isLoading: false; sameAddress: false };

    @Prop({ type: Object })
    public vm!: CheckoutReviewViewModel;

    public $refs!: { fieldValueCollectionEditor: any };

    public additionalInfoValid = false;

    protected validateAddressField(value: string) {
        if (value) {
            return true;
        }
        return "You must enter a value";
    }

    public resetValidation() {
        this.$refs.fieldValueCollectionEditor?.resetValidation();
    }

    public validate() {
        return this.$refs.fieldValueCollectionEditor?.validate();
    }
}
